import * as Autosuggest from 'react-autosuggest'
import * as React from 'react'
import TextFieldProps = __MaterialUI.TextFieldProps
import TextField from 'material-ui/TextField'
import {SuggestionsFetchRequest} from 'react-autosuggest'
import {ProductCalculationDetailsAction} from '../ProductCalculationDetailsActions'
import {
    getDisplayedText, getRenderFunctionForMessageSuggestions, getValuedText
} from './AutoSuggestionHelper'
import {MessageWithTranslation} from '../../../Entities/MessageWithTranslation.entity.evolve'
import {renderSuggestion, shouldRenderSuggestions} from '../../../View/MaterialAutosuggest'

export function ProductCalculationAutoSuggestionSelect({
                                                           disabled,
                                                           dispatch,
                                                           keyType,
                                                           label,
                                                           stateValue,
                                                           stateSuggestions,
}: {
    disabled: boolean,
    dispatch: (action: ProductCalculationDetailsAction) => void,
    keyType: string,
    label: string,
    stateValue: string,
    stateSuggestions: MessageWithTranslation[]
}) {
    if (disabled) {
        return (
            <div>
                <TextField
                    floatingLabelText={label}
                    type="text"
                    value={stateValue}
                    disabled={true}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    fullWidth={true}
                />
                <div style={{clear: 'both'}} />
            </div>
        )
    } else {
        return <Autosuggest
            suggestions={stateSuggestions}
            onSuggestionsFetchRequested={
                (value: SuggestionsFetchRequest) => {
                    dispatch({
                        type: 'FetchProductCalculationMessageSuggestions',
                        key: keyType,
                        value: value.value,
                    })
                }}
            onSuggestionsClearRequested={
                () => dispatch({
                    type: 'ClearProductCalculationMessageSuggestions',
                    key: keyType
                })}
            getSuggestionValue={getValuedText(stateValue)}
            inputProps={{
                value: stateValue,
                onChange: (// tslint:disable-next-line
                    event: any,
                    {newValue}: { newValue: string }) => dispatch({
                    type: 'ProductCalculationMessageSearchChanged',
                    key: keyType,
                    value: newValue,
                }),
            }}
            onSuggestionSelected={
                (// tslint:disable-next-line
                    event: any,
                    {suggestion}: { suggestion: MessageWithTranslation }) => dispatch({
                    type: 'ProductCalculationMessageChanged',
                    key: keyType,
                    value: suggestion,
                })}
            renderInputComponent={
                (inputProps: TextFieldProps) =>
                    <TextField
                        {...inputProps}
                        floatingLabelText={label}
                        fullWidth={true}
                    />
            }
            renderSuggestionsContainer={getRenderFunctionForMessageSuggestions}
            renderSuggestion={renderSuggestion(getDisplayedText)}
            shouldRenderSuggestions={shouldRenderSuggestions}
            allwaysRenderSuggestions={true}
        />
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationDetails/AutoSuggestions/ProductCalculationAutoSuggestionSelect.tsx